"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.scss");
var __1 = require("../");
var ExpandablePanelList = /** @class */ (function (_super) {
    tslib_1.__extends(ExpandablePanelList, _super);
    function ExpandablePanelList(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.renderContent = function (isExpanded) {
            var _a = _this.props, items = _a.items, maxItems = _a.maxItems, ItemComponent = _a.itemComponent, itemKey = _a.itemKey;
            var displayItems = items;
            if (!isExpanded && maxItems > 0 && items.length > maxItems) {
                displayItems = items.slice(0, maxItems);
            }
            return (React.createElement("div", { className: theme.content }, displayItems.map(function (item) { return React.createElement(ItemComponent, { key: item[itemKey], item: item, isExpanded: isExpanded }); })));
        };
        return _this;
    }
    ExpandablePanelList.prototype.render = function () {
        var _a = this.props, items = _a.items, maxItems = _a.maxItems, ItemComponent = _a.itemComponent, itemKey = _a.itemKey, others = tslib_1.__rest(_a, ["items", "maxItems", "itemComponent", "itemKey"]);
        return React.createElement(__1.ExpandablePanel, tslib_1.__assign({}, others, { renderContent: this.renderContent }));
    };
    ExpandablePanelList.defaultProps = {
        maxItems: 6
    };
    return ExpandablePanelList;
}(React.Component));
exports.default = ExpandablePanelList;
